import React from 'react';
import ChallengeDetailsHeaderCard from '../ChallengeDetailsHeaderCard.react';
import Typography from '@mui/material/Typography';

function VirtuosoHeaderCard(): React.Element {
  return (
    <ChallengeDetailsHeaderCard 
      title="Virtuoso Challenges" 
      moreDetails={
        <Typography variant="body2" gutterBottom component="div">
          A list of challenges from the Virtuoso group
        </Typography>
      }
      borderClass={"ratedBorder NONE"}
    />
  );
}

export default VirtuosoHeaderCard;
